import { Box } from "@material-ui/core";
import { observer } from "mobx-react-lite"
import { StyledTitle } from "../attributes-management/Styles";
import { LinkedInChildApplicationResponse } from "../../models/linkedin-manager/LinkedInChildApplicationResponse";
import { Alert } from "antd";

interface Props {
    linkedinChildApplication?: LinkedInChildApplicationResponse;
}

const LinkedinChildApplication = (props: Props) => {

    const { linkedinChildApplication } = props;
    type AlertType = "warning" | "error" | "info" | undefined;

    // Helper function to generate alert message and type
    const getAlertMessageAndType = (linkedinChildApplication?: LinkedInChildApplicationResponse)
        : { message: string | null, type: AlertType, display: boolean } => {

        if (!linkedinChildApplication) {
            return {
                message: "This account isn't connected to a LinkedIn child application",
                type: "error",
                display: true
            };
        }
        return {
            message: null, // No alert message needed
            type: undefined,
            display: false
        };
    };

    const { message, type, display } = getAlertMessageAndType(linkedinChildApplication);

    return (
        <>
            {display && (
                <Box display="flex" my={3}>
                    <Alert
                        description={message}
                        type={type}
                        showIcon
                    />
                </Box>
            )}
            <Box my={3}>
                <StyledTitle>
                    <span>Linkedin child application: {linkedinChildApplication ? linkedinChildApplication.name : "None"}</span>
                </StyledTitle>
            </Box>
        </>
    );
};
export default observer(LinkedinChildApplication)


